export default __webpack_public_path__ + "static/media/p_1.7cb450eb.jpg";